import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ConditionProfessionnel } from "src/app/professionnel/core/model/condition-professionnel";
import { ConditionProfessionnelService } from "src/app/professionnel/core/service/condition-professionnel.service";

@Component({
  selector: "app-form-edit-condition",
  templateUrl: "./form-edit-condition.component.html",
  styleUrls: ["./form-edit-condition.component.scss"],
})
export class FormEditConditionComponent implements OnInit {
  @Input() conditionId;

  requestId: number;

  condition: ConditionProfessionnel;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _conditionProfessionnelService: ConditionProfessionnelService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      libelle: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getConditionProfessionnelById(this.conditionId);
  }

  getConditionProfessionnelById(conditionid) {
    this._conditionProfessionnelService
      .getConditionProfessionnelById(conditionid)
      .subscribe(
        (data) => {
          this.condition = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  edit(): void {
    this.spinner.show();
    this._conditionProfessionnelService
      .putConditionProfessionnel(this.condition)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
